import React from 'react';
import styled from 'styled-components';
import { Window } from '../Window/Window';

const ResumeContainer = styled.div`
  background: #c0c0c0;
  padding: 20px;
  height: 100%;
  overflow-y: auto;
  font-family: 'MS Sans Serif', sans-serif;
  color: #000;
`;

const Content = styled.div`
  background: #d4d0c8;
  padding: 20px;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
`;

const Title = styled.div`
  font-family: 'MS Sans Serif', sans-serif;
  margin-bottom: 20px;
`;

const Text = styled.p`
  line-height: 1.5;
  margin-bottom: 15px;
`;

const Links = styled.div`
  margin-top: 20px;
  
  a {
    color: #000080;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Resume = ({ 
  onClose, 
  isActive, 
  onActivate, 
  isMinimized, 
  isMaximized, 
  onMinimize, 
  onMaximize,
  initialPosition
}) => {
  return (
    <Window
      title="Resume"
      onClose={onClose}
      isActive={isActive}
      onActivate={onActivate}
      isMinimized={isMinimized}
      isMaximized={isMaximized}
      onMinimize={onMinimize}
      onMaximize={onMaximize}
      initialPosition={initialPosition}
      defaultWidth="800px"
      defaultHeight="350px"
    >
      <ResumeContainer>
        <Content>
        <h1>david r - buildooor</h1>
        <br />
          <Title>currently:   web3 marketing manager @ Tezos & Etherlink</Title>
          
          <Text>
            right now, i'm focused on making the etherlink ecosystem as good as it can be—boosting tvl, 
            liquidity, and ux to make the chain feel smoother and easier to get into.
          </Text>
          
          <Text>
            working on products and incentives that drive real usage and long-term growth. been deep 
            in marketing, community, and product across web3.
          </Text>

          <Links>
                      if you want to chat or need my actual resume, find me on <a href="https://x.com/0xDavidR" target="_blank" rel="noopener noreferrer">X</a> or <a href="https://www.linkedin.com/in/david-r-038504226/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </Links>
        </Content>
      </ResumeContainer>
    </Window>
  );
}; 